import React, { Suspense } from "react";
import axios from "axios";
import {
  defer,
  Await,
  useLoaderData,
  Link,
  useNavigate,
  useActionData,
  Form,
} from "react-router-dom";

import {
  ListGroup,
  ListGroupItem,
  Col,
  Button,
  Row,
  Container,
  Card,
} from "react-bootstrap";
/**
 * @author
 * @function TechopsUserTool
 **/

const TechopsUserTool = (props) => {
  const navigate = useNavigate();
  const actionData = useActionData();
  const loaderData = useLoaderData();

  let js = "";

  return (
    <>
      <div>
        <Container>
          <Row>
            <h1>TechOps Tools Search</h1>
            <Col md={8} lg={6} xs={12}>
              User Details
              <p>&nbsp;</p>
            </Col>
          </Row>

          <Suspense fallback={<p>Loading...</p>}>
            <ListGroup className="shadow">
              <Await resolve={loaderData.user}>
                {(user) => (
                  <div className="p-4">
                    <Row>
                      <Col className="col-2 text-end">User Id:</Col>
                      <Col>{user.userId}</Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">First Name:</Col>
                      <Col>{user.firstName}</Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">Last Name:</Col>
                      <Col>{user.lastName}</Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">is Verified:</Col>
                      <Col>
                        {user.verified == 0 ? "Verified" : "Not Verified"}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">Status:</Col>
                      <Col>{user.status == 0 ? "Active" : "Deactivated"}</Col>
                    </Row>
                    <Row className="p-2">
                      <Col className="col-3"></Col>
                      <Col className="col-3">
                        <Form
                          method="post"
                          action={"/techopsTool/user/" + user.userId}
                        >
                          <Button
                            className="btn btn-small"
                            type="submit"
                            disabled={user.status != "0" ? true : false}
                          >
                            Deactivate User
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                )}
              </Await>
            </ListGroup>
          </Suspense>
          {actionData && actionData.status === "Success" && (
            <p style={{ textAlign: "center" }}>{actionData.message}</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default TechopsUserTool;

export async function loader({ params }) {
  const userId = params.userId;

  return defer({ user: getUser(userId) });
}

async function getUser(userId) {
  let jwtinfo = localStorage.getItem("prod-ftjwt");

  const response = await axios.get("/api/v1/techopsUser/" + userId, {
    headers: {
      "Content-Type": "application/json",
      apikey: "xxyyzz",
      token: jwtinfo,
    },
  });

  return response.data;
}

export async function action({ request, params }) {
  const userId = params.userId;
  let jwtinfo = localStorage.getItem("prod-ftjwt");

  const response = await axios.post(
    "/api/v1/disableUser/" + userId,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        apikey: "xxyyzz",
        token: jwtinfo,
      },
    }
  );

  return response.data;
}
